import airPods from "../images/airpods.png"
import imac from "../images/imac.png"
import iphone from "../images/iphone.png"
import mac_mini from "../images/mac-mini.png"
import pencil from "../images/pencil.png"
import smartwatch from "../images/smartwatch.png"

export const products = [
    {id: 1, title: 'AirPods', description: 'Description', price: 1.49, img: airPods},
    {id: 2, title: 'Imac', description: 'Description', price: 3.49, img: imac},
    {id: 3, title: 'Iphone', description: 'Description', price: 3.99, img: iphone},
    {id: 4, title: 'IMacMini', description: 'Description', price: 7.99, img: mac_mini},
    {id: 5, title: 'IPencil', description: 'Description', price: 3.99, img: pencil},
    {id: 6, title: 'IWatch', description: 'Description', price: 3.99, img: smartwatch},
]